
import { Vue, Options, prop } from "vue-class-component";
import { I18N_LOCALES } from "@/i18n/locales";
class Props {
  id = prop<string>({
    default: "",
    type: String
  });
}
@Options({})
export default class SelectReceiptLanguage extends Vue.with(Props) {
  currentIndex = 0;
  isMouseDown = false;

  mounted() {
    this.$i18n.locale = "en";
  }
  unmounted() {
    this.$i18n.locale = "id";
  }
  get activeLocale() {
    return I18N_LOCALES[this.$i18n.locale];
  }
  get availableLanguage() {
    const languangesUsed = this.$i18n.availableLocales.slice(0, 2);
    return languangesUsed.map((locale: string) => {
      return I18N_LOCALES[locale];
    });
  }

  showListAvailableLanguage = false;
  toggleListAvailableLanguage() {
    this.showListAvailableLanguage = !this.showListAvailableLanguage;
    this.$nextTick(() => {
      if (this.showListAvailableLanguage) {
        const ref = this.$refs["changeLanguage-0"] as any
        ref?.focus();
      }
    })
  }
  forceCloseListAvailableLanguage() {
    this.showListAvailableLanguage = false;
  }

  changeLanguageReceipt(value: string) {
    this.$i18n.locale = value;
    this.toggleListAvailableLanguage();
  }

  onFocusListLanguage() {
    if(!this.isMouseDown) {
      this.toggleListAvailableLanguage();
    }
  }


  onItemKeydown(e: KeyboardEvent) {
    const lastIndex = this.currentIndex + 1 === this.availableLanguage.length;
    if ((e.key === "Escape" || (e.key === "Tab" && lastIndex) || (e.key === "Tab" && e.shiftKey))) {
      this.currentIndex = 0;
      (this.$refs as any)[`changeLanguage-${this.currentIndex}`]?.focus();
      setTimeout(() => {
        this.forceCloseListAvailableLanguage();
      }, 50)
    } else if (e.key === "ArrowDown" || (e.key === "Tab" && !lastIndex)) {
      e.preventDefault();
      const nextIndex = (this.currentIndex + 1) % this.availableLanguage.length;
      (this.$refs as any)?.[`changeLanguage-${nextIndex}`]?.focus();
      this.currentIndex = nextIndex;
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const prevIndex = (this.currentIndex - 1 + this.availableLanguage.length) % this.availableLanguage.length;
      (this.$refs as any)?.[`changeLanguage-${prevIndex}`]?.focus();
      this.currentIndex = prevIndex;
    }
  }
}
